import { restore, createEvent } from 'effector';

export type GroupBy = 'none' | 'on' | 'kun' | 'radical';

export const groupBy = createEvent<GroupBy>()

export const $groupBy = restore(groupBy, 'none');
